import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = { class: "assets-grid-card" }
const _hoisted_4 = { class: "assets-grid-card__header" }
const _hoisted_5 = { class: "assets-grid-title" }
const _hoisted_6 = { class: "assets-grid-title__text" }
const _hoisted_7 = { class: "assets-grid-controls" }
const _hoisted_8 = { class: "assets-search" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "assets-grid-card__body" }
const _hoisted_16 = { class: "device-data-cell" }
const _hoisted_17 = { class: "device-name-badge" }
const _hoisted_18 = { class: "device-content" }
const _hoisted_19 = { class: "device-title" }
const _hoisted_20 = {
  key: 0,
  class: "device-meta"
}
const _hoisted_21 = { class: "groups-cell" }
const _hoisted_22 = {
  key: 0,
  class: "groups-list"
}
const _hoisted_23 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_24 = { class: "sensors-cell" }
const _hoisted_25 = {
  key: 0,
  class: "param-chip sensor-chip"
}
const _hoisted_26 = { class: "sensor-chip__label" }
const _hoisted_27 = { class: "sensor-chip__value" }
const _hoisted_28 = {
  key: 1,
  class: "param-chip sensor-chip"
}
const _hoisted_29 = { class: "sensor-chip__label" }
const _hoisted_30 = { class: "sensor-chip__value" }
const _hoisted_31 = {
  key: 2,
  class: "param-chip sensor-chip"
}
const _hoisted_32 = { class: "sensor-chip__label" }
const _hoisted_33 = { class: "sensor-chip__value" }
const _hoisted_34 = {
  key: 3,
  class: "param-chip sensor-chip"
}
const _hoisted_35 = { class: "sensor-chip__label" }
const _hoisted_36 = { class: "sensor-chip__value" }
const _hoisted_37 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_38 = { class: "single-param-cell" }
const _hoisted_39 = {
  key: 2,
  class: "param-chip param-chip--empty"
}
const _hoisted_40 = { class: "single-param-cell" }
const _hoisted_41 = {
  key: 0,
  class: "param-chip"
}
const _hoisted_42 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_43 = { class: "single-param-cell" }
const _hoisted_44 = {
  key: 0,
  class: "param-chip"
}
const _hoisted_45 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_46 = { class: "single-param-cell" }
const _hoisted_47 = {
  key: 0,
  class: "param-chip"
}
const _hoisted_48 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_49 = { class: "single-param-cell" }
const _hoisted_50 = {
  key: 0,
  class: "param-chip"
}
const _hoisted_51 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_52 = { class: "single-param-cell" }
const _hoisted_53 = {
  key: 0,
  class: "param-chip"
}
const _hoisted_54 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_55 = { class: "last-activity-wrapper" }
const _hoisted_56 = ["title"]
const _hoisted_57 = { class: "status-pill__top" }
const _hoisted_58 = { class: "status-label" }
const _hoisted_59 = { class: "status-time" }
const _hoisted_60 = { class: "action-buttons" }
const _hoisted_61 = ["title", "onClick"]
const _hoisted_62 = ["title", "onClick"]
const _hoisted_63 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AssetsDashboard = _resolveComponent("AssetsDashboard")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_AssetDefaultLocationModal = _resolveComponent("AssetDefaultLocationModal")!
  const _component_AssetImagesModal = _resolveComponent("AssetImagesModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AssetsDashboard),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-hdd-rack-fill" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('components.assets.dataGrids.assetsList')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                type: "search",
                placeholder: _ctx.$t('components.assets.dataGrids.searchPlaceholder'),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args))),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)), ["esc"]))
              }, null, 40, _hoisted_9), [
                [_vModelText, _ctx.searchText]
              ]),
              (_ctx.searchText)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "assets-search__clear",
                    title: _ctx.$t('components.assets.dataGrids.clearSearch'),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                  ]))], 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["assets-toolbar-btn", { active: _ctx.showFilters }]),
              title: _ctx.$t('components.assets.dataGrids.filters'),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleFilters && _ctx.toggleFilters(...args)))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-funnel" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.filters')), 1)
            ], 10, _hoisted_11),
            (_ctx.hasFilters || _ctx.searchText)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "assets-toolbar-btn",
                  title: _ctx.$t('components.assets.dataGrids.clear'),
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-eraser" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.clear')), 1)
                ], 8, _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assets.dataGrids.refresh'),
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.refreshGrid && _ctx.refreshGrid(...args)))
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.refresh')), 1)
            ], 8, _hoisted_13),
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assets.dataGrids.columns'),
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openColumnChooser && _ctx.openColumnChooser(...args)))
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-layout-three-columns" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.columns')), 1)
            ], 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.gridRef,
            "data-source": _ctx.store,
            "hover-state-enabled": true,
            "remote-operations": true,
            "column-auto-width": false,
            "show-borders": false,
            "show-column-lines": false,
            "show-row-lines": false,
            scrolling: _ctx.scrollingConfig,
            "column-hiding-enabled": true,
            "word-wrap-enabled": true,
            onOptionChanged: _ctx.onGridOptionChanged,
            onContentReady: _ctx.onGridContentReady,
            onContextMenuPreparing: _ctx.onContextMenuPreparing,
            onToolbarPreparing: _ctx.onToolbarPreparing,
            onCellPrepared: _ctx.onCellPrepared
          }, {
            "device-data-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "device-icon" }, [
                    _createElementVNode("i", { class: "bi bi-hdd-rack-fill" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(data.data.name || '—'), 1),
                    (_ctx.getSerialNumber(data.data) !== '—')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-upc-scan" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getSerialNumber(data.data)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            "group-names-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_21, [
                (_ctx.getGroupNames(data.data).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroupNames(data.data), (groupName, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `group-${data.data.id}-${index}`,
                          class: "param-chip group-chip"
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-diagram-3" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(groupName), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, " — "))
              ])
            ]),
            "sensors-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_24, [
                (_ctx.getTemperature(data.data) !== '—' || _ctx.getHumidity(data.data) !== '—' || _ctx.getPowerSupply(data.data) !== '—' || _ctx.getGatewayPower(data.data) !== '—')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.getTemperature(data.data) !== '—')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('components.assets.dataGrids.temperature')), 1),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.getTemperature(data.data)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getHumidity(data.data) !== '—')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-droplet-half" }, null, -1)),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('components.assets.dataGrids.humidity')), 1),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getHumidity(data.data)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getPowerSupply(data.data) !== '—')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-lightning-charge-fill" }, null, -1)),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('components.assets.dataGrids.power')), 1),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.getPowerSupply(data.data)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getGatewayPower(data.data) !== '—')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-broadcast" }, null, -1)),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('components.assets.dataGrids.gatewayPower')), 1),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.getGatewayPower(data.data)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, " — "))
              ])
            ]),
            "battery-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_38, [
                (_ctx.getBatteryStatus(data.data) !== '—')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["param-chip battery-chip", _ctx.getBatteryStatusClass(data.data)])
                    }, [
                      _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-battery-charging" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getBatteryStatus(data.data)), 1)
                    ], 2))
                  : (_ctx.getGpsPowerStatusText(data.data) !== '—')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["param-chip battery-chip", _ctx.getGpsPowerStatusClass(data.data)])
                      }, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-plug-fill" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.getGpsPowerStatusText(data.data)), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_39, " — "))
              ])
            ]),
            "x-axis-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_40, [
                (_ctx.getAxisValue(data.data, 'X_AXIS') !== '—')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-arrows-move" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getAxisValue(data.data, 'X_AXIS')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, " — "))
              ])
            ]),
            "y-axis-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_43, [
                (_ctx.getAxisValue(data.data, 'Y_AXIS') !== '—')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _cache[25] || (_cache[25] = _createElementVNode("i", { class: "bi bi-arrows-vertical" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getAxisValue(data.data, 'Y_AXIS')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_45, " — "))
              ])
            ]),
            "z-axis-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_46, [
                (_ctx.getAxisValue(data.data, 'Z_AXIS') !== '—')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _cache[26] || (_cache[26] = _createElementVNode("i", { class: "bi bi-arrows-collapse" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getAxisValue(data.data, 'Z_AXIS')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_48, " — "))
              ])
            ]),
            "magnitude-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_49, [
                (_ctx.getAxisMagnitude(data.data) !== '—')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _cache[27] || (_cache[27] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getAxisMagnitude(data.data)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_51, " — "))
              ])
            ]),
            "magnitude-no-gravity-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_52, [
                (_ctx.getAxisMagnitudeNoGravity(data.data) !== '—')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _cache[28] || (_cache[28] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getAxisMagnitudeNoGravity(data.data)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_54, " — "))
              ])
            ]),
            "last-activity-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", {
                  class: _normalizeClass(["status-pill", _ctx.getLastActivityClass(data.data)]),
                  title: `${_ctx.getOnlineStatusLabel(data.data)} • ${_ctx.getLastActivity(data.data)}`
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _cache[29] || (_cache[29] = _createElementVNode("span", {
                      class: "status-dot",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.getOnlineStatusLabel(data.data)), 1)
                  ]),
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.getLastActivity(data.data)), 1)
                ], 10, _hoisted_56)
              ])
            ]),
            "actions-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary",
                  title: _ctx.$t('components.assets.dataGrids.details'),
                  onClick: ($event: any) => (_ctx.onPreview({ row: { key: data.data.id, data: data.data } }))
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                ]))], 8, _hoisted_61),
                (_ctx.shouldShowLocationButton(data.data))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-outline-success",
                      title: _ctx.$t('components.assets.dataGrids.setDefaultLocation'),
                      onClick: ($event: any) => (_ctx.openDefaultLocationModal(data.data))
                    }, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("i", { class: "bi bi-geo-alt" }, null, -1)
                    ]))], 8, _hoisted_62))
                  : _createCommentVNode("", true),
                (_ctx.canEdit && !_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-sm btn-outline-secondary",
                      title: _ctx.$t('components.assets.images.manage'),
                      onClick: ($event: any) => (_ctx.openAssetImagesModal(data.data))
                    }, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
                    ]))], 8, _hoisted_63))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: _ctx.showFilters }, null, 8, ["visible"]),
              _createVNode(_component_DxFilterRow, {
                visible: _ctx.showFilters && !_ctx.isMobile
              }, null, 8, ["visible"]),
              _createVNode(_component_DxPaging, { "page-size": 20 }),
              _createVNode(_component_DxPager, {
                "allowed-page-sizes": [5, 10, 20, 25, 50],
                "show-info": true,
                "show-navigation-buttons": true,
                "show-page-size-selector": true,
                visible: true
              }),
              _createVNode(_component_DxColumnChooser, {
                enabled: true,
                mode: "select",
                "allow-search": true,
                title: _ctx.$t('components.assets.dataGrids.columns')
              }, null, 8, ["title"]),
              _createVNode(_component_DxColumn, {
                name: "deviceData",
                "data-field": "name",
                caption: _ctx.$t('components.assets.dataGrids.deviceData'),
                "cell-template": "device-data-template",
                "allow-hiding": false,
                "show-in-column-chooser": false
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                name: "groupNames",
                "data-field": "group_names",
                caption: _ctx.$t('components.assets.dataGrids.groups'),
                "cell-template": "group-names-template",
                width: 250,
                alignment: "center",
                visible: !_ctx.isMobile,
                "hiding-priority": 1,
                "allow-hiding": true,
                "allow-filtering": false
              }, null, 8, ["caption", "visible"]),
              _createVNode(_component_DxColumn, {
                name: "sensors",
                caption: _ctx.$t('components.assets.dataGrids.sensors'),
                "cell-template": "sensors-template",
                "allow-filtering": false,
                alignment: "center",
                width: 170,
                "hiding-priority": 2,
                "allow-hiding": false,
                "show-in-column-chooser": false
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                name: "batteryStatus",
                caption: _ctx.$t('components.assets.dataGrids.batteryStatus'),
                "cell-template": "battery-template",
                "allow-filtering": false,
                alignment: "center",
                width: 150,
                "hiding-priority": 3,
                "allow-hiding": false,
                "show-in-column-chooser": false
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                name: "xAxis",
                caption: _ctx.$t('components.assets.dataGrids.xAxis'),
                "cell-template": "x-axis-template",
                "allow-filtering": false,
                alignment: "center",
                width: _ctx.isMobile ? 110 : 150,
                "hiding-priority": 7,
                visible: false
              }, null, 8, ["caption", "width"]),
              _createVNode(_component_DxColumn, {
                name: "yAxis",
                caption: _ctx.$t('components.assets.dataGrids.yAxis'),
                "cell-template": "y-axis-template",
                "allow-filtering": false,
                alignment: "center",
                width: _ctx.isMobile ? 110 : 150,
                "hiding-priority": 8,
                visible: false
              }, null, 8, ["caption", "width"]),
              _createVNode(_component_DxColumn, {
                name: "zAxis",
                caption: _ctx.$t('components.assets.dataGrids.zAxis'),
                "cell-template": "z-axis-template",
                "allow-filtering": false,
                alignment: "center",
                width: _ctx.isMobile ? 110 : 150,
                "hiding-priority": 9,
                visible: false
              }, null, 8, ["caption", "width"]),
              _createVNode(_component_DxColumn, {
                name: "magnitude",
                caption: _ctx.$t('components.assets.dataGrids.magnitude'),
                "cell-template": "magnitude-template",
                "allow-filtering": false,
                alignment: "center",
                width: _ctx.isMobile ? 140 : 190,
                "hiding-priority": 10,
                visible: false
              }, null, 8, ["caption", "width"]),
              _createVNode(_component_DxColumn, {
                name: "magnitudeNoGravity",
                caption: _ctx.$t('components.assets.dataGrids.magnitudeNoGravity'),
                "cell-template": "magnitude-no-gravity-template",
                "allow-filtering": false,
                alignment: "center",
                width: _ctx.isMobile ? 140 : 210,
                "hiding-priority": 11,
                visible: false
              }, null, 8, ["caption", "width"]),
              _createVNode(_component_DxColumn, {
                name: "lastActivity",
                caption: _ctx.$t('components.assets.dataGrids.lastActivity'),
                "cell-template": "last-activity-template",
                "allow-filtering": false,
                alignment: "center",
                width: 250,
                "hiding-priority": 4,
                "allow-hiding": false,
                "show-in-column-chooser": false
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                name: "actions",
                caption: _ctx.$t('components.assets.dataGrids.actions'),
                width: _ctx.isMobile ? 90 : 120,
                "allow-filtering": false,
                alignment: "center",
                "cell-template": "actions-template",
                "hiding-priority": 5,
                "allow-hiding": false,
                "show-in-column-chooser": false
              }, null, 8, ["caption", "width"])
            ]),
            _: 1
          }, 8, ["data-source", "scrolling", "onOptionChanged", "onContentReady", "onContextMenuPreparing", "onToolbarPreparing", "onCellPrepared"])
        ])
      ])
    ]),
    _createVNode(_component_AssetDefaultLocationModal, {
      ref: "defaultLocationModalRef",
      onSaved: _ctx.handleAssetLocationSaved
    }, null, 8, ["onSaved"]),
    _createVNode(_component_AssetImagesModal, {
      ref: "assetImagesModalRef",
      onSaved: _ctx.handleAssetImagesSaved
    }, null, 8, ["onSaved"])
  ]))
}